import { CButton, CImg } from '@coreui/react';
import * as React from 'react';
import { IImageProvider } from '../../abstraction';
import { Utils } from '../../core/utils';
import { ActionModel } from '../../models/index';

interface IProps {
	Action: ActionModel,
	onClick: (action: ActionModel) => void,
	imageProvider: IImageProvider,
}

// Repr�sente un bouton d'action (mapp� au contr�le x3 de type action)
export class KControlAction extends React.Component<IProps> {
	public constructor(props: any) {
		super(props);
	}

	//#region Ev�nements locaux

	// Clic sur le bouton action
	onClick = () => {
		if (this.props.onClick) this.props.onClick(this.props.Action);
	}

	//#endregion

	//#region Rendus

	renderImg = (code: string) => {
		let img = this.props.imageProvider.getImg(code);
		if (img) {
			return <CImg src={img} />
		}
		return "";
	}

	render() {
		let action = this.props.Action;
		if (!action.Visible) return null;

		let inlineStyle = Utils.decodeInlineStyleFromJson(action.InlineStyle);
		let img = this.renderImg(action.Icon);
		return (
			<div className={`KControl KControlButton `+ action.Class} >
				<CButton className={action.Class} size="sm" type="submit" role="button" style={inlineStyle} disabled={action.Disable} name={action.Key} color={action.Color} onClick={this.onClick}>
					{img}
					<span className={action.InnerCSS + " " + action.Class}>{action.Text}</span>
                </CButton>
			</div>
		)
	}

	//#endregion
}